import { withInstall } from '@lit-element/utils'

import Qrcode from './src/qrcode.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtQrcode: SFCWithInstall<typeof Qrcode> = withInstall(Qrcode)
export default LtQrcode

export * from './src/qrcode'
